import { styled } from "../stitches.config";
import { Button } from "../components/Button";
import { TextField } from "./TextField";
import { Select } from "../components/Select";

export const ControlGroup = styled("div", {
  display: "flex",

  // Make sure ControlGroup and its children don't affect normal stacking order
  position: "relative",
  zIndex: 0,

  [`& ${Button}`]: {
    borderRadius: 0,
    boxShadow:
      "inset 0 1px $colors$neutral7, inset -1px 0 $colors$neutral7, inset 0 -1px $colors$neutral7",
    "&:hover": {
      boxShadow:
        "-1px 0 $colors$neutral8, inset 0 1px $colors$neutral8, inset -1px 0 $colors$neutral8, inset 0 -1px $colors$neutral8",
    },
    "&:focus": {
      zIndex: 1,
      boxShadow: "inset 0 0 0 1px $colors$neutral8, 0 0 0 1px $colors$neutral8",
    },
    "&:first-child": {
      borderTopLeftRadius: "$1",
      borderBottomLeftRadius: "$1",
      boxShadow: "inset 0 0 0 1px $colors$neutral7",
      "&:hover": {
        boxShadow: "inset 0 0 0 1px $colors$neutral8",
      },
      "&:focus": {
        boxShadow:
          "inset 0 0 0 1px $colors$neutral8, 0 0 0 1px $colors$neutral8",
      },
    },
    "&:last-child": {
      borderTopRightRadius: "$1",
      borderBottomRightRadius: "$1",
      boxShadow:
        "inset 0 1px $colors$neutral7, inset -1px 0 $colors$neutral7, inset 0 -1px $colors$neutral7",
      "&:focus": {
        boxShadow:
          "inset 0 0 0 1px $colors$neutral8, 0 0 0 1px $colors$neutral8",
      },
    },
  },
  [`& ${TextField}`]: {
    borderRadius: 0,
    boxShadow:
      "inset 0 1px $colors$neutral7, inset -1px 0 $colors$neutral7, inset 0 -1px $colors$neutral7",
    "&:focus": {
      zIndex: 1,
      boxShadow:
        "inset 0px 0px 0px 1px $colors$blue8, 0px 0px 0px 1px $colors$blue8",
    },
    "&:first-child": {
      borderTopLeftRadius: "$1",
      borderBottomLeftRadius: "$1",
      boxShadow: "inset 0 0 0 1px $colors$neutral7",
      "&:focus": {
        boxShadow:
          "inset 0px 0px 0px 1px $colors$blue8, 0px 0px 0px 1px $colors$blue8",
      },
    },
    "&:last-child": {
      borderTopRightRadius: "$1",
      borderBottomRightRadius: "$1",
      boxShadow:
        "inset 0 1px $colors$neutral7, inset -1px 0 $colors$neutral7, inset 0 -1px $colors$neutral7",
      "&:focus": {
        boxShadow:
          "inset 0px 0px 0px 1px $colors$blue8, 0px 0px 0px 1px $colors$blue8",
      },
    },
  },
  [`& ${Select}`]: {
    borderRadius: 0,
    boxShadow:
      "inset 0 1px $colors$neutral7, inset -1px 0 $colors$neutral7, inset 0 -1px $colors$neutral7",
    "&:focus-within": {
      boxShadow:
        "inset 0px 0px 0px 1px $colors$blue8, 0px 0px 0px 1px $colors$blue8",
    },
    "&:first-child": {
      borderTopLeftRadius: "$1",
      borderBottomLeftRadius: "$1",
      boxShadow: "inset 0 0 0 1px $colors$neutral7",
      "&:focus-within": {
        boxShadow:
          "inset 0px 0px 0px 1px $colors$blue8, 0px 0px 0px 1px $colors$blue8",
      },
    },
    "&:last-child": {
      borderTopRightRadius: "$1",
      borderBottomRightRadius: "$1",
      boxShadow:
        "inset 0 1px $colors$neutral7, inset -1px 0 $colors$neutral7, inset 0 -1px $colors$neutral7",
      "&:focus-within": {
        boxShadow:
          "inset 0px 0px 0px 1px $colors$blue8, 0px 0px 0px 1px $colors$blue8",
      },
    },
  },
});
